module.exports = __webpack_public_path__ + "assets/img/free_7.482b5f5a.png";